import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {choose} from 'lit/directives/choose.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import store from '../../../store';
import {LocationState} from '../../../slices/lightProfileSlice';

@customElement('visual-solar-activity-level')
export class VisualSolarActivityLevel extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 100%;
			height: 100%;
			overflow: hidden;
		}
		.container {
			height: 40%;
			max-height: 220px;
			margin: auto;
			display: flex;
		}
		@media (max-width: 768px) {
			.container {

			}
		}
		.svg {
			height: 100%;
			margin: auto;
			display: block;
			padding-bottom: 20%;
		}

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.region = state.status.region;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.location = state.lightProfile.data.project.location;
		this.locationState = state.lightProfile.data.locationState;

	}
	render() {
		const s = this.state;
		return html`
			<div class="container">
				<svg-activity-level class="svg"></svg-activity-level>
			</div>
		`;
	}
}
